import * as React from 'react'
import { translateCountryName } from "@ui-seeker/utils"

import {RetailerBlock} from "@components";


export default function retailerColumn() {
    return [{
		name: 'country', label: 'Country',
		options: {
			display: 'excluded',
			customBodyRowRender: v => translateCountryName(v)
		}
	},{
        name: 'retailer', label: 'Retailer',
        options: {
            customBodyRowRenderLite: (value, { country, siteURL, pageURL }) => <RetailerBlock
				retailer={value}
				country={country}
                siteURL={siteURL}
                pageURL={pageURL}
			/>
        }
    }]
}